import React from "react";
import { FaAward } from "react-icons/fa";
import { VscFolderLibrary } from "react-icons/vsc";
import ME from "../../assets/myphoto2.jpg";
import "./intro.css";

const Intro = () => {
  return (
    <section id="about">
      <h5>Get to know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <div>
              <img src={ME} />
            </div>
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Education</h5>
              <small>Bachelor of Commerce</small>
            </article>

            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>3+ Completed Projects</small>
            </article>
          </div>
          <p>
            Enthusiastic and motivated full-stack web developer with expertise
            in Java, HTML5, CSS3, and React. Completed a full-stack web
            development course at Masai School and possesses strong
            problem-solving skills. Demonstrates the ability to work
            independently and as part of a team, with excellent time management
            and adaptability skills. Seeking an entry-level position in web
            development to contribute to the success of the organization.
          </p>
          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default Intro;
